export const SET_SCHEMES_RATE = "SET_SCHEMES_RATE";

export const setSchemesRate = (schemesRate) => ({
  type: SET_SCHEMES_RATE,
  payload: schemesRate,
});
